//@ts-check
import { myxchngApiClient } from '../../utils/RequestClient';
import RequestSearchParams from '../../utils/RequestSearchParams';

/**
 *
 * @param {object} params
 * @param {string[]} params.appIds
 * @param {string} [params.token]
 * @param {AbortSignal} [params.signal]
 * @returns {Promise<import('@action-types/ccApp').CcAppsResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/ecApp').MyxchngApiErrorResponse>}
 */
const getCcAppsById = async ({ signal, token, appIds }) => {
  const search = new RequestSearchParams({ ids: appIds.join(',') });
  const headers = new Headers();
  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }
  const { jsonResponse } = await myxchngApiClient.fetch({
    endpoint: `/ccapps${search}`,
    requestOptions: {
      signal,
      headers,
    },
  });
  return jsonResponse;
};

export default getCcAppsById;
